import { ArkActionTypes } from '../../../../../actions/dashboards/Ark'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { TopStores } from '../../types'
import { StoresTopPayload } from '../../types'

/**
 * Ark Top Stores reducer
 */
const arkTopStores = buildAsyncStatReducer({
    key: Metrics.ARK_TOP_STORES,
    types: ArkActionTypes.DASHBOARD_ARK_TOP_STORES,
    transform: (state, { payload }): TopStores => {
        return payload.map(({ store_code: storeCode, count }: StoresTopPayload) => ({
            storeCode,
            count,
        }))
    },
})

export default arkTopStores
